import { getCore } from '../../../../../client/core/getCore';
import type { DynamicClient } from '../../../../../client/types';

export const createSignInMessageStatement = (client: DynamicClient) => {
  const core = getCore(client);

  const appName =
    core.metadata?.name ?? client.projectSettings?.general.displayName;

  return `Welcome to ${appName}. Signing is the only way we can truly know that you are the owner of the wallet you are connecting. Signing is a safe, gas-less transaction that does not in any way give ${appName} permission to perform any transactions with your wallet.`;
};
